

import useAuthentication from "@hooks/useAuthentication";
import PatientBookingv1 from "./v1";
import PatientBookingV2 from "./v2";

function PatientBookingByGrants() {

 const {user}= useAuthentication();
 const calenderType = user?.calendar

  return (
    <>
    
    
    {calenderType == "NORMAL_CALENDAR".toLowerCase() ? (
      <PatientBookingv1 />
    ) : (
      <PatientBookingV2 />
    )}
    </>
   
       

  );
}

export default PatientBookingByGrants;
